import * as z from "zod";

/**
 * Toggle the Shopify storefront script tag (Redo's fallback loader). This is an
 * internal implementation control — the handler additionally verifies the
 * caller is a Redo employee, and the client only surfaces it to Redo admins.
 */
export const enableStorefrontScriptTag = {
  name: "enableStorefrontScriptTag" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.object({ scriptTagEnabled: z.boolean() }),
};
